<ion-grid [fixed]="true">
  <ion-row>
    <ion-col size="12" size-md="4">
      <div class="stats-wrap">
        <ion-text color="success"
          ><h3>{{ "PRINT.ORDER.STATUS.CREATED" | translate }}</h3></ion-text
        >
        <ion-text
          ><h3 class="stats-number">{{ newOrderQuantity() }}</h3></ion-text
        >
      </div>
    </ion-col>
    <ion-col size="12" size-md="4">
      <div class="stats-wrap">
        <ion-text color="primary"
          ><h3>{{ "PRINT.ORDER.STATUS.IN_PROGRESS" | translate }}</h3></ion-text
        >
        <ion-text
          ><h3 class="stats-number">{{ activeOrderQuantity() }}</h3></ion-text
        >
      </div>
    </ion-col>
    <ion-col size="12" size-md="4">
      <div class="stats-wrap">
        <ion-text
          ><h3>{{ "PRINT.ORDER.STATUS.COMPLETED" | translate }}</h3></ion-text
        >
        <ion-text
          ><h3 class="stats-number">{{ completedOrderQuantity() }}</h3></ion-text
        >
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" size-md="12">
      <div class="stats-wrap">
        <ion-text  color="success"
          ><h3>{{"PRINT.ORDER.EARNED.AMOUNT" | translate}}</h3></ion-text
        >
        <ion-text
          ><h3 class="stats-number">{{ totalEarned() }} {{"CURRENCY.TEXT" | translate}}</h3></ion-text
        >
      </div>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-grid>
  <ion-row>
    <ion-col size="12" size-sm="3" class="ion-text-start">
      <ion-button [routerLink]="'availability'">{{
        "PRINT.OFFICE.ORDER.TABLE.ORDER.STATUS.CHANGE.AVAILABILITY" | translate
      }}</ion-button>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <app-custom-sp-table
        [columns]="columns"
        [rowData]="orders()"
        (rowClicked)="onRowClick($event)"
        [actions]="actions">
      </app-custom-sp-table>
    </ion-col>
  </ion-row>
</ion-grid>
